import styles from './styles.module.scss';

type Props = {
  value: number;
  handleIncrease: () => void;
  handleDecrease: () => void;
  label: string;
  disabledDecrease?: boolean;
  disabledIncrese?: boolean;
};

const Counter = ({
  label,
  value,
  handleIncrease,
  handleDecrease,
  disabledDecrease = false,
  disabledIncrese = false,
}: Props) => (
  <div className={styles.counterWrapper}>
    {label && <div className={styles.label}>{label}</div>}
    <div className={styles.counter}>
      <button
        className={styles.decrease}
        onClick={handleDecrease}
        disabled={disabledDecrease}
      >
        <svg width="17" height="2" viewBox="0 0 17 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1.36277H16" stroke="#363636" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div className={styles.num}>{value}</div>
      <button
        className={styles.increase}
        onClick={handleIncrease}
        disabled={disabledIncrese}
      >
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 8.36277H16" stroke="#363636" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8.5 1V15.7258" stroke="#363636" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  </div>
);


export default Counter;
